import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import {
  doGetAllGroups,
  doCreateGroup,
  doUpdateGroup,
  doDeleteGroup,
  doUpdateGroupInviteEmail,
  doUpdateGroupDisInviteEmail,
  doGetGroupInviteEmails,
  doOffGroupInviteEmails,
  doGroupAcceptInvite,
  doGroupGetDetailCode,
} from "./thunk";

const groupsAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const groupSlice = createSlice({
  name: "group",
  initialState: {
    action: null,
    isFetching: false,
    status: "idle",
    metadata: {},
    entities: [],
    ids: [],
    invite: {},
    detailCode: {},
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllGroups.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doGetAllGroups.fulfilled, (state, action) => {
      const { groups, meta } = action.payload;
      state.isFetching = false;
      state.status = "succeeded";
      state.metadata = meta;
      groupsAdapter.setAll(state, groups);
    });
    builder.addCase(doGetAllGroups.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doCreateGroup.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doCreateGroup.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      groupsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreateGroup.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doUpdateGroup.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateGroup.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      groupsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateGroup.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDeleteGroup.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDeleteGroup.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      groupsAdapter.removeOne(state, action.meta.arg);
    });
    builder.addCase(doDeleteGroup.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });

    builder.addCase(doUpdateGroupInviteEmail.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateGroupInviteEmail.fulfilled, state => {
      state.isFetching = false;
      state.status = "succeeded";
    });
    builder.addCase(doUpdateGroupInviteEmail.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });

    builder.addCase(doUpdateGroupDisInviteEmail.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateGroupDisInviteEmail.fulfilled, state => {
      state.isFetching = false;
      state.status = "succeeded";
    });
    builder.addCase(doUpdateGroupDisInviteEmail.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });

    builder.addCase(doGetGroupInviteEmails.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doGetGroupInviteEmails.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.invite = action.payload;
    });
    builder.addCase(doGetGroupInviteEmails.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });

    builder.addCase(doOffGroupInviteEmails.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doOffGroupInviteEmails.fulfilled, (state, action) => {
      console.log(action.meta.arg.inviteStatus);
      state.isFetching = false;
      state.status = "succeeded";
      state.invite = {
        ...state.invite,
        status: action.meta.arg.inviteStatus,
        code: action.payload.inviteCode,
      };
    });
    builder.addCase(doOffGroupInviteEmails.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });

    builder.addCase(doGroupAcceptInvite.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doGroupAcceptInvite.fulfilled, state => {
      state.isFetching = false;
      state.status = "succeeded";
      state.detailCode = {};
    });
    builder.addCase(doGroupAcceptInvite.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });

    builder.addCase(doGroupGetDetailCode.pending, state => {
      state.isFetching = true;
      state.status = "loading";
      state.action = "DetailCode";
    });
    builder.addCase(doGroupGetDetailCode.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.detailCode = action.payload;
      state.action = null;
    });
    builder.addCase(doGroupGetDetailCode.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
      state.action = null;
    });
  },
});

export const {
  selectAll: selectAllGroups,
  selectById: selectGroupById,
  selectIds: selectGroupIds,
} = groupsAdapter.getSelectors(state => state.group);

const { reducer: groupReducer } = groupSlice;
export default groupReducer;
